const US_STATE_OPTIONS = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY", "DC",
];

export function EditIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="16" height="16" aria-hidden>
      <path
        d="M505 122.9L517.1 135C526.5 144.4 526.5 159.6 517.1 168.9L488 198.1L441.9 152L471 122.9C480.4 113.5 495.6 113.5 504.9 122.9zM273.8 320.2L408 185.9L454.1 232L319.8 366.2C316.9 369.1 313.3 371.2 309.4 372.3L250.9 389L267.6 330.5C268.7 326.6 270.8 323 273.7 320.1zM437.1 89L239.8 286.2C231.1 294.9 224.8 305.6 221.5 317.3L192.9 417.3C190.5 425.7 192.8 434.7 199 440.9C205.2 447.1 214.2 449.4 222.6 447L322.6 418.4C334.4 415 345.1 408.7 353.7 400.1L551 202.9C579.1 174.8 579.1 129.2 551 101.1L538.9 89C510.8 60.9 465.2 60.9 437.1 89zM152 128C103.4 128 64 167.4 64 216L64 488C64 536.6 103.4 576 152 576L424 576C472.6 576 512 536.6 512 488L512 376C512 362.7 501.3 352 488 352C474.7 352 464 362.7 464 376L464 488C464 510.1 446.1 528 424 528L152 528C129.9 528 112 510.1 112 488L112 216C112 193.9 129.9 176 152 176L264 176C277.3 176 288 165.3 288 152C288 138.7 277.3 128 264 128L152 128z"
        fill="#FFFFFF"
      />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden>
      <path d="M2 2L10 10M10 2L2 10" stroke="#8B8FA3" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

function SelectChevronIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden>
      <polyline
        points="6 9 12 15 18 9"
        stroke="#8087A0"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ErrorAlertIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
      <circle cx="9" cy="9" r="8" stroke="#F87171" strokeWidth="1.5" />
      <path d="M9 5v5" stroke="#F87171" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="9" cy="12.75" r="0.9" fill="#F87171" />
    </svg>
  );
}

export default function CheckMailingAddressEditForm({
  draft,
  onFieldChange,
  onSave,
  onCancel,
  isSaving = false,
  embedded = false,
  title = "Update Mailing Address",
  subtitle = "Make sure your check goes to the right place.",
  saveLabel = "Save Address",
  savingLabel = "Saving…",
  errorBanner = null,
}) {
  const form = (
    <>
      {!embedded && (
        <div className="bc-check-mailing-edit-header">
          <h2 className="bc-check-mailing-edit-title">{title}</h2>
          <p className="bc-check-mailing-edit-subtitle">{subtitle}</p>
        </div>
      )}

      {errorBanner && (
        <div className="bc-check-mailing-edit-error" role="alert">
          <span className="bc-check-mailing-edit-error-icon">
            <ErrorAlertIcon />
          </span>
          <div className="bc-check-mailing-edit-error-copy">
            <p className="bc-check-mailing-edit-error-title">{errorBanner.title}</p>
            <p className="bc-check-mailing-edit-error-body">{errorBanner.message}</p>
          </div>
        </div>
      )}

      <div className="bc-check-mailing-edit-form">
        <label className="bc-check-mailing-edit-field">
          <span className="bc-check-mailing-edit-label">Street address</span>
          <input
            type="text"
            className="bc-check-mailing-edit-input"
            value={draft.address1}
            onChange={(e) => onFieldChange("address1", e.target.value)}
            aria-label="Street address"
          />
        </label>

        <div className="bc-check-mailing-edit-field-row">
          <label className="bc-check-mailing-edit-field">
            <span className="bc-check-mailing-edit-label">Apt / Unit</span>
            <input
              type="text"
              className="bc-check-mailing-edit-input"
              value={draft.address2}
              onChange={(e) => onFieldChange("address2", e.target.value)}
              aria-label="Apt or unit"
            />
          </label>
          <label className="bc-check-mailing-edit-field">
            <span className="bc-check-mailing-edit-label">City</span>
            <input
              type="text"
              className="bc-check-mailing-edit-input"
              value={draft.city}
              onChange={(e) => onFieldChange("city", e.target.value)}
              aria-label="City"
            />
          </label>
        </div>

        <div className="bc-check-mailing-edit-field-row">
          <label className="bc-check-mailing-edit-field">
            <span className="bc-check-mailing-edit-label">State</span>
            <span className="bc-check-mailing-edit-select-wrap">
              <select
                className="bc-check-mailing-edit-select"
                value={draft.state}
                onChange={(e) => onFieldChange("state", e.target.value)}
                aria-label="State"
              >
                <option value="">Select</option>
                {draft.state && !US_STATE_OPTIONS.includes(draft.state) && (
                  <option value={draft.state}>{draft.state}</option>
                )}
                {US_STATE_OPTIONS.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
              <SelectChevronIcon />
            </span>
          </label>
          <label className="bc-check-mailing-edit-field">
            <span className="bc-check-mailing-edit-label">Zip code</span>
            <input
              type="text"
              className="bc-check-mailing-edit-input"
              value={draft.zipCode}
              onChange={(e) => onFieldChange("zipCode", e.target.value)}
              aria-label="Zip code"
            />
          </label>
        </div>
      </div>

      <div className="bc-check-mailing-edit-actions">
        <button type="button" className="bc-check-mailing-edit-save" onClick={onSave} disabled={isSaving}>
          {isSaving ? savingLabel : saveLabel}
        </button>
        <button type="button" className="bc-check-mailing-edit-cancel" onClick={onCancel} disabled={isSaving}>
          Cancel
        </button>
      </div>
    </>
  );

  if (embedded) {
    return <div className="bc-check-mailing-edit-form-embedded">{form}</div>;
  }

  return (
    <div className="bc-check-mailing-edit-card">
      <button type="button" className="bc-check-mailing-edit-close" aria-label="Close" onClick={onCancel}>
        <CloseIcon />
      </button>
      {form}
    </div>
  );
}
